import { IconType } from 'components/Icon';
import Section from 'components/Panel/Section';
import FontInput from 'components/Widget/Input/FontInput';
import { Font, Style } from 'dragonmouse-shared/style';
import { MenuItemAction } from 'menu/MenuItem';
import React from 'react';
import { useDispatch } from 'react-redux';
import { showContextMenu } from 'redux/mode/actions';
import { displayViewOnlyModal } from 'redux/mode/util';
import * as Panel from '../../../styles';
import * as DS from '../styles';

interface FontSetupProps {
	activeStyle: Style;
	updateCurrentStyle: (update: Partial<Style>) => void;
	viewOnly?: boolean;
}
const FontSetup = ({ activeStyle, updateCurrentStyle, viewOnly }: FontSetupProps) => {
	const dispatch = useDispatch();

	const onAddFont = () => {
		if (viewOnly) {
			displayViewOnlyModal();
			return;
		}
		if (!activeStyle) return;
		const font: Font = {
			value: '',
		};
		updateCurrentStyle({ fonts: [...(activeStyle.fonts || []), font] });
	};

	const onFontContextMenu = (e: React.MouseEvent, index: number) => {
		if (!activeStyle) return;
		if (e.target instanceof HTMLElement) {
			dispatch(
				showContextMenu({
					point: { x: e.clientX, y: e.clientY },
					menuItems: [
						new MenuItemAction('Delete font', '', () => {
							updateCurrentStyle({ fonts: activeStyle.fonts.filter((_, i) => i !== index) });
						}),
					],
				})
			);
		}
	};

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------
	return (
		<Section
			label="Fonts"
			actions={[
				{
					tooltip: 'Add font',
					icon: IconType.ADD,
					onClick: onAddFont,
				},
			]}
		>
			{activeStyle?.fonts?.map((font, index) => (
				<DS.PropertyRow key={index} onContextMenu={(e) => onFontContextMenu(e, index)}>
					<FontInput
						font={font.value}
						onFontChange={(font) => {
							if (viewOnly) {
								displayViewOnlyModal();
								return;
							}
							updateCurrentStyle({
								fonts: activeStyle.fonts.map((f, i) => (i === index ? { ...f, value: font } : f)),
							});
						}}
					/>
				</DS.PropertyRow>
			))}
			{activeStyle?.fonts?.length > 0 ? <Panel.Spacer /> : <Panel.HalfSpacer />}
		</Section>
	);
};

export default FontSetup;
